import { LOCALE } from '@hhgtech/hhg-components/types'

export const InSkinAdLocales: LOCALE[] = [
  LOCALE.Thailand,
  LOCALE.Taiwan,
  LOCALE.India,
  LOCALE.Indonesia,
  LOCALE.Malaysia,
  LOCALE.PhilippinesEnglish,
  LOCALE.PhilippinesTagalog,
  LOCALE.Cambodia,
  LOCALE.Myanmar,
  LOCALE.Vietnam,
]
